export const martaMalecka = {
    'meta': {
        'title': 'Seksuolog, psychoterapeuta Marta Małecka • Centrum COLLIGO',
        'description': 'Jestem doktorem nauk humanistycznych. Studia z zakresu seksuologii klinicznej ukończyłam na Uniwersytecie im. Adama Mickiewicza w Poznaniu.'
    },
    'url': {
        'address': '/torun/zespol/seksuolog-psychoterapeuta-marta-malecka/'
    },
    'opengraph': {
        'image': {
            'url': '/images/team/open-graph/marta-malecka.webp',
            'width': 150,
            'height': 150,
            'alt': 'Seksuolog, psychoterapeuta Marta Małecka, Toruń'
        }
    }
}